import { countryOptions } from './countries.js';

// Product choices (same codes as server/modules/listings/fields.js) and
// the rows shown on the public page, the admin review and the wizard
// summary.

export const UNITS = ['kg', 'lb', 'tonne', 'piece', 'dozen', 'metre', 'sq_metre', 'cu_metre', 'litre', 'gallon', 'box', 'carton', 'bag', 'roll', 'set', 'pallet', 'container_20', 'container_40', 'truckload'];
export const INCOTERMS = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP'];
export const MAX_SPECS = 4;
export const MAX_ADVANTAGES = 4;

const locale = (lang) => (lang === 'en' ? 'en-CA' : 'fr-CA');
let countryCache = {};
export function countryName(code, lang) {
  if (!code) return '';
  countryCache[lang] ||= Object.fromEntries(countryOptions(lang).map((c) => [c.code, c.name]));
  return countryCache[lang][code] || code;
}

export function formatAmount(n, unit, lang, t) {
  if (n === null || n === undefined || n === '') return '';
  const v = new Intl.NumberFormat(locale(lang), { maximumFractionDigits: 2 }).format(Number(n));
  return unit ? `${v} ${t(`units.${unit}`)}` : v;
}

export const incotermLabel = (code, t) => (code ? `${code} — ${t(`incoterms.${code}`)}` : '');

// Trade details grid.
export function tradeRows(l, t, lang) {
  const sample = l.sampleAvailable === true
    ? (l.sampleCostBy ? t('product.sampleYesBy', { by: t(`product.costBy.${l.sampleCostBy}`) }) : t('common.yes'))
    : l.sampleAvailable === false ? t('common.no') : '';
  return [
    ['moq', formatAmount(l.moq, l.moqUnit, lang, t)],
    ['quantity', l.quantity !== null && l.quantity !== undefined && l.quantity !== '' ? `${formatAmount(l.quantity, null, lang, t)}${l.unit ? ` ${l.unit}` : ''}` : ''],
    ['incoterm', incotermLabel(l.incoterm, t)],
    ['paymentTerms', (l.paymentTerms || []).map((c) => t(`payment.${c}Long`)).join(', ')],
    ['deliveryTime', l.deliveryTime],
    ['originCountry', countryName(l.originCountry, lang)],
    ['loadingPort', l.loadingPort],
    ['productionCapacity', l.productionCapacity],
    ['packaging', l.packaging],
    ['sample', sample],
  ].filter(([, v]) => v);
}

// Specifications table: the seller's key specs, then the product identifiers.
export function specRows(l, t, lang) {
  // Values of the category's spec fields; several for chips (one row).
  const groups = new Map();
  for (const s of (l.catalogSpecs || l.specsChosen || []).filter((x) => x.labelFr || x.labelEn)) {
    const g = groups.get(s.groupId) || { label: (lang === 'en' ? s.labelEn : s.labelFr) || s.labelFr, values: [] };
    g.values.push(lang === 'en' ? s.valueEn || s.value : s.value);
    groups.set(s.groupId, g);
  }
  return [
    ...[...groups.values()].map((g) => [g.label, g.values.join(', '), true]),
    ...(l.specs || []).filter((s) => s.label && s.value).map((s) => [s.label, s.value, true]),
    ...[['grade', l.grade], ['brand', l.brand], ['modelNo', l.modelNo], ['trademark', l.trademark], ['hsCode', l.hsCode], ['standards', l.standards]]
      .filter(([, v]) => v).map(([k, v]) => [t(`product.fields.${k}`), v, false]),
  ];
}
